import { productImageZoom } from './product-image-zoom.i18n';

export const en = {
  productImageZoom,
};
